import axios from 'axios';
import _ from 'lodash';

import {typesCruisedet} from '../svtypes/cruisedetTypes'

import { SV_SOJ_ORCMOCK_ADDRESS ,CARN_URL,IM_SOURCE_TYPE,IM_AWS,IM_SVAMCOS,COSMOS_IM_URL, IM_PSURLS_AWS} from '../../constants';

const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export function getCruisedetDetails(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(getCruisedetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourDetailView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data.push(sod)
                    });

                   
                    dispatch(getCruisedetSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getCruisedetSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getCruisedetError(e))
        )
    }
}




export const getCruisedetSuccess = (data) => dispatch => {
    dispatch({
        type: typesCruisedet.GET_CRUISEDET_SUCCESS,
        payload: data
    })
}
export const getCruisedetMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: typesCruisedet.GET_CRUISEDET_SUCCESS,
        payload: data
    })
}

export const getCruisedetBegin = () => dispatch => {
    dispatch({
        type:typesCruisedet.GET_CRUISEDET_BEGIN
        
    })
}

export const getCruisedetError = (e) =>dispatch => {
    dispatch({
        type:typesCruisedet.GET_CRUISEDET_ERROR,
        error:e
    })
}




/*svdec19 fix to get with ID 
export function cliAndImagesCruisePaginate1HotelById(sojPostRqFromPage,  svcli_esquery_data){
   
    console.log("sv NOV!5*** cliAndImagesSV ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruisedetBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
       

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
      
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            if(_.isObject(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage
            }
            
           
  
       
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
           
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {svo} = rFobMerge
                console.log('86 sending svo ',svo)
                const comData = { my_data: [], my_data_geo:{}}
                let arWithOneExcursiob = []
                let aExcursion = null
                if(svo && (svo.length > 0) ){
                    aExcursion = svo[0]
                    arWithOneExcursiob.push(aExcursion)
                    comData.my_data = arWithOneExcursiob
                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                dispatch(getCruisedetMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruisedetError(e))}
           
        )
    }
}
*/

export function cliAndImagesCruisePaginate1HotelById_usesCrusiceode(sojPostRqFromPage,  svcli_esquery_data){
    /* SV TODO this Code */
    console.log("sv NOV!5*** cliAndImagesSV ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruisedetBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcShcedule`
       

          let sojPostRq ={
            "docId":["GA2_SEA_SP_7_Tue_ols"],
            "hsetname":"GA2_SEA_SP_7_Tue_ols"
            }
      
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            if(_.isObject(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage
            }
            
           
  
            /*svaug29 end*/
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
           
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {cruiseExes} = rFobMerge
                console.log('86 sending cruiseExes ',cruiseExes)
                const comData = { my_data: [], my_data_geo:{}}
                let arWithOneExcursiob = []
                let aExcursion = null
                if(cruiseExes && (cruiseExes.length > 0) ){
                    aExcursion = cruiseExes[0]
                    let ess = aExcursion.exSchedules

                    /*svdec21  start*/
                for(let m=0; m< ess.length; m++){
                    let imgs = [],carn_images = null
                   carn_images = ess[m].images
                   if(carn_images && (carn_images.length > 0) ){
                    carn_images.forEach(im =>{
                        let sim =  CARN_URL +  im.path 
                        imgs.push(sim)
                       })
                    }else{
                        imgs = r2.data.images
                    }
                    ess[m].imgs = imgs
                }
                /*svdec21  end*/


                    arWithOneExcursiob.push(aExcursion)
                    comData.my_data = arWithOneExcursiob
                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                dispatch(getCruisedetMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruisedetError(e))}
           
        )
    }
}


export function cliAndImagesCruisePaginate1HotelById_svbak_jun6Working(sojPostRqFromPage,  svcli_esquery_data){
    /* SV TODO this Code */
    console.log("sv NOV!5*** cliAndImagesSV ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruisedetBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcShceduleByExcursionId`
       

          let sojPostRq ={
            "docId":["5"],
            "hsetname":"5"
            }
      
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            if(_.isObject(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage
            }
            
           
  
            /*svaug29 end*/
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
           
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {cruiseExes} = rFobMerge
                console.log('86 sending cruiseExes ',cruiseExes)
                const comData = { my_data: [], my_data_geo:{}}
                let arWithOneExcursiob = []
                let aExcursion = null
                if(cruiseExes && (cruiseExes.length > 0) ){
                    aExcursion = cruiseExes[0]
                    let ess = aExcursion.exSchedules

                    /*svdec21  start*/
                for(let m=0; m< ess.length; m++){
                    let imgs = [],carn_images = null
                   carn_images = ess[m].images
                   if(carn_images && (carn_images.length > 0) ){
                    carn_images.forEach(im =>{
                        //let sim =  CARN_URL +  im.path 
                        /*svmay29 start*/
                        let sim =''
                        
                        if(IM_SOURCE_TYPE == IM_AWS){
                            let s= im.path 
                            let m  = s.replace('00/SVPS3/', '')
                            sim =  COSMOS_IM_URL +  m 
                            console.log('svmay29*******S3', sim)

                        }else{

                             sim =  CARN_URL +  im.path 
                             console.log('svmay29*******86',sim)
                        }
                         /*svmay29 end*/
                        imgs.push(sim)
                       })
                    }else{
                        imgs = r2.data.images
                    }
                    ess[m].imgs = imgs
                }
                /*svdec21  end*/


                    arWithOneExcursiob.push(aExcursion)
                    comData.my_data = arWithOneExcursiob
                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                dispatch(getCruisedetMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruisedetError(e))}
           
        )
    }
}




/*svjun9 start ***********/

export function cliAndImagesCruisePaginate1HotelById(sojPostRqFromPage,  svcli_esquery_data){
    /* SV TODO this Code */
    console.log("sv NOV!5*** cliAndImagesSV ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruisedetBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcShceduleByExcursionId`
        if(IM_SOURCE_TYPE == IM_AWS){
            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcShceduleByExcursionId`
           
        }else if(IM_SOURCE_TYPE == IM_PSURLS_AWS){
            
            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcShceduleByExcursionIdPS`

        }else{

            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcShceduleByExcursionId`
        }

          let sojPostRq ={
            "docId":["5"],
            "hsetname":"5"
            }
      
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            if(_.isObject(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage
            }
            
           
  
            /*svaug29 end*/
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
           
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {cruiseExes} = rFobMerge
                console.log('86 sending cruiseExes ',cruiseExes)
                const comData = { my_data: [], my_data_geo:{}}
                let arWithOneExcursiob = []
                let aExcursion = null
                if(cruiseExes && (cruiseExes.length > 0) ){
                    aExcursion = cruiseExes[0]
                    let ess = aExcursion.exSchedules

                    /*svdec21  start*/
                for(let m=0; m< ess.length; m++){
                    let imgs = [],carn_images = null
                   carn_images = ess[m].images
                   if(carn_images && (carn_images.length > 0) ){
                    carn_images.forEach(im =>{
                        //let sim =  CARN_URL +  im.path 
                        /*svmay29 start*/
                        let sim =''
                        
                        if(IM_SOURCE_TYPE == IM_AWS){
                            let s= im.path 
                            let m  = s.replace('00/SVPS3/', '')
                            sim =  COSMOS_IM_URL +  m 
                            console.log('svmay29*******S3', sim)

                        }else if(IM_SOURCE_TYPE == IM_PSURLS_AWS){
                            
                            sim = im.psurls
                            console.log('svmay29*******S3', sim)


                        }else{

                             sim =  CARN_URL +  im.path 
                             console.log('svmay29*******86',sim)
                        }
                         /*svmay29 end*/
                        imgs.push(sim)
                       })
                    }else{
                        imgs = r2.data.images
                    }
                    ess[m].imgs = imgs
                }
                /*svdec21  end*/


                    arWithOneExcursiob.push(aExcursion)
                    comData.my_data = arWithOneExcursiob
                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                dispatch(getCruisedetMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruisedetError(e))}
           
        )
    }
}

/*svjun9 end*/